import { render, staticRenderFns } from "./ResumenCifrasV2.vue?vue&type=template&id=939bfcd2&"
import script from "./ResumenCifrasV2.vue?vue&type=script&lang=js&"
export * from "./ResumenCifrasV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports